import { CONFIG } from 'config/'

export function isPowerTier(tier) {
    return tier === CONFIG.POWER_TIER
}

export function isFoundationTier(tier) {
    return tier === CONFIG.FOUNDATION_TIER
}
